import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getAssetsByIds } from '@uplift/api';
import { BaseQueryOpts } from './baseTypes';
import * as batshit from '@yornaath/batshit';


export const useAssetsQuery = (assetIds: string[], opts?: BaseQueryOpts) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: [ 'assets', assetIds ],
    queryFn: async () => {
      if (assetIds?.length === 0) {
        return {};
      }
      const assetsResponse = await getAssetsByIds(assetIds);

      return assetsResponse.data;
    },
    ...opts,
    onSuccess: (data) => {
      Object.keys(data).forEach(key => {
        queryClient.setQueryData([ 'assets', key ], data[key]);
      });
    }
  });
};


const publicAssetBatch = batshit.create({
  fetcher: async (assetIds: string[]) => {
    const response = await getAssetsByIds(assetIds.filter(Boolean));

    return response.data;
  },
  resolver: (response, key) => response?.[key],
  scheduler: batshit.windowScheduler(10)
});


export const useAssetQuery = (assetId?: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'assets', assetId ],
    queryFn: async () => {
      if (!assetId) {
        return null;
      }

      return await publicAssetBatch.fetch(assetId);
    },
    staleTime: Infinity,
    ...opts,
  });
};
